import { makeAutoObservable } from 'mobx';
import ExternalRoleViewModel from './ExternalRoleViewModel';

class ExternalUserViewModel {
  user;
  roles = [];

  constructor(user, context) {
    makeAutoObservable(this);

    this.user = user;
    this.roles = context.allRoles.map(r => new ExternalRoleViewModel(r, this));
  }
}

export default ExternalUserViewModel;
